import React from "react";
import { Link, useLocation } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/paysuccess.css";

const formatMoney = (value) =>
  new Intl.NumberFormat(siteConfig.currency.locale, {
    style: "currency",
    currency: siteConfig.currency.code,
  }).format(Number(value) || 0);

const PaySuccess = () => {
  const location = useLocation();
  const { orderNumber, total, email, deliveryMethod } = location.state || {};

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="payment-success">
      <div className="payment-success__frame">
        <p className="payment-success__brand">{siteConfig.brandName}</p>
        <div className="payment-success__mark" role="img" aria-label="Order confirmed">
          <svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">
            <circle cx="32" cy="32" r="30" />
            <path d="m18 33 9 9 20-22" />
          </svg>
        </div>

        <p className="payment-success__eyebrow">Order received</p>
        <h1>Thank you for your selection.</h1>
        <p className="payment-success__copy">
          {email
            ? `A demo confirmation has been prepared for ${email}. No payment was taken.`
            : "Your demo order is confirmed. No payment was taken."}
        </p>

        {(orderNumber || Number.isFinite(total)) && (
          <dl className="payment-success__details">
            {orderNumber && (
              <div>
                <dt>Order reference</dt>
                <dd>{orderNumber}</dd>
              </div>
            )}
            {Number.isFinite(total) && (
              <div>
                <dt>Order total</dt>
                <dd>{formatMoney(total)}</dd>
              </div>
            )}
            {deliveryMethod && (
              <div>
                <dt>Delivery</dt>
                <dd>{deliveryMethod === "express" ? "Express" : "Standard"}</dd>
              </div>
            )}
          </dl>
        )}

        <div className="payment-success__actions">
          <Link to="/shop" onClick={toTop}>
            Continue shopping
          </Link>
          <Link to="/contact" onClick={toTop}>
            Contact the atelier
          </Link>
        </div>
      </div>
    </main>
  );
};

export default PaySuccess;
